<form [formGroup]="form" (submit)="onSubmitted()" class="form">
  <div class="fields">
    <app-input-password-field
      [form]="form"
      [id]="'password'"
      [controlName]="'password'"
      [key]="'auth.resetPassword.password'"
      [class]="'field'"
    ></app-input-password-field>
    <app-input-password-field
      [form]="form"
      [id]="'passwordRepeat'"
      [controlName]="'passwordRepeat'"
      [key]="'auth.resetPassword.passwordRepeat'"
      [class]="'field'"
    ></app-input-password-field>
    <button type="submit" class="button button-primary" [disabled]="form.invalid" translate>auth.resetPassword.submit</button>
  </div>
</form>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/reset-password/reset-password-form/reset-password-form.component.html